import defaultTheme from './defaultTheme';
const athletaTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#565656', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#565656', background: '#565656' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#565656' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#565656', border: '#565656', background: '#565656' }), field: {
        focus: '#565656',
        label: '#565656',
        icon: '#565656',
    } });
export default athletaTheme;
